/**
 * Samweb WebClient
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type AuthenticationMethod = 1 | 2 | 3;

export const AuthenticationMethod = {
    Samwin: 1 as AuthenticationMethod,
    Domain: 2 as AuthenticationMethod,
    MicrosoftEntraId: 3 as AuthenticationMethod
};